/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OfferTerminationNotes
 */
export interface OfferTerminationNotes {
}

/**
 * Check if a given object implements the OfferTerminationNotes interface.
 */
export function instanceOfOfferTerminationNotes(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OfferTerminationNotesFromJSON(json: any): OfferTerminationNotes {
    return OfferTerminationNotesFromJSONTyped(json, false);
}

export function OfferTerminationNotesFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferTerminationNotes {
    return json;
}

export function OfferTerminationNotesToJSON(value?: OfferTerminationNotes | null): any {
    return value;
}

